module.exports = __webpack_public_path__ + "img/arrow-left-red.a75132c0.svg";